import React from 'react';
import styles from './RatingPage.module.css';

export function movementText(change) {
  if (!Number.isInteger(change)) return null;
  if (change === 0) return 'Без изменений за неделю';
  const n = Math.abs(change);
  const word = n % 10 === 1 && n % 100 !== 11 ? 'место' : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14) ? 'места' : 'мест';
  return `${change > 0 ? '↑' : '↓'} ${n} ${word} за неделю`;
}

export default function RankMovement({ change, comparedAt }) {
  const text = movementText(change);
  if (!text) return null;
  const date = comparedAt && new Date(comparedAt).toLocaleString('ru-RU', { timeZone: 'Europe/Moscow' });
  return <span className={`${styles.movement} ${change > 0 ? styles.movementUp : change < 0 ? styles.movementDown : ''}`} title={date ? `Сравнение с позицией на ${date} МСК` : undefined}>{text}</span>;
}
